export default "__VITE_ASSET__BPQYH_n9__"